import dean from "../media/speakers/Dean_Bezlov.png";
import georgik from "../media/speakers/Georgi_Kostadinov.png";
import georgim from "../media/speakers/Georgi_Manolov.png";
import mihai from "../media/speakers/Mihai_Draghici.png";
import nevil from "../media/speakers/Neville_Mchina.png";
import spas from "../media/speakers/Spas_Kerimov.png";
import teod from "../media/speakers/Teodosi_Teodosiev.png";
import xav from "../media/speakers/Xavier_Marcenac.png";
import dent from "../media/speakers/Denitza_Tyufekchieva.png";
import ventt from "../media/speakers/Ventsislav_Topuzov.png";
import vikm from "../media/speakers/Viktoriya_Markilieva.png";
import yonko from "../media/speakers/Yonko_Chuklev.png";

const panels = {
    panel1: [
        {
            speakerName: "Georgi Manolov",
            company: "Nexo",
            businessSphere: "Blockchain, Crypto",
            theme: "Building World-Class Fintech",
            duration: 25,
            eventType: "Speech",
            socialLink: "https://www.facebook.com/georgemanolov",
            img: georgim,
            bio: "Георги Манолов е възпитаник на Американския университет в България и Вашингтонския университет в Сейнт Луис, САЩ. Крипто и блокчейн ентусиаст, през 2020 г. издава бестселъра „Стандартът Биткойн” на българския пазар. Георги води ключови проекти за бизнес развитие, като договаря банкови, платежни и рекламни партньорства с водещи компании в крипто индустрията за Nexo — българската компания, една от водещите институции за управление на дигитални активи в света.",
        },
        {
            speakerName: "Mihai Draghici",
            company: "PayByFace",
            businessSphere: "Fintech, Biometrics",
            theme: "You Are Your Credit Card",
            duration: 10,
            eventType: "Speech",
            socialLink: "https://www.linkedin.com/in/mihai-radu-draghici/",
            img: mihai,
            bio: "Mihai Draghici is a serial entrepreneur and a startup mentor, who has graduated from The University of Texas at San Antonio. Mihai has more than 20 years of experience in turning ideas into products and has launched several startups in markets all around the world including Romania, Bulgaria, Netherlands, UAE, USA, Canada, South Africa, Mexico and India. Apart from his excellent entrepreneurial skills, Mihai is also a full stack senior software engineer and systems architect with many years of experience working on enterprise cloud platforms, mobile apps, databases, web services and various performance frameworks. He is now focusing on his company – PayByFace that allows consumers to simply use their own face as a means to buy and sell goods and services.",
        },
        {
            speakerName: "Dean Bezlov",
            company: "MYX",
            businessSphere: "DeepTech, AI",
            theme: "Digital Twins of the World in Your Pocket",
            duration: 15,
            eventType: "Interview",
            socialLink: "https://www.linkedin.com/in/dean-bezlov-myx/",
            img: dean,
            bio: "Dean has graduated from the Sofia High School of Mathematics and the prestigious UK university in Warwick. Currently he is Head of Business Development at MYX. This is a Bulgarina startup, which produces incredibly accurate digital representations of the real world surroundings. Their work can be accessed with a smartphone. The AI algorithms analyze the surroundings helping businessmen make an informed decision.",
        },
        {
            speakerName: "Denitza Tyufekchieva",
            company: "Propy",
            businessSphere: "Blockchain in Real Estate",
            theme: "A Real Restate of the Real Estate Industry/",
            duration: 15,
            eventType: "Interview",
            socialLink:
                "https://www.linkedin.com/in/denitza-tyufekchieva-18890b50/",
            img: dent,
            bio: "Denitza Tyufekchieva is a co-founder and vice president of Propy, author, mentor, and advisor to technology startups. She is recognized worldwide as one of the first women in the blockchain ecosystem and part of the Forbes 30 under 30 selection in 2018. In 2017, Denitza Tyufekchieva led Propy's token sale initiative, attracting 6,000 participants and $ 16 million. She is responsible for managing Propy's business and marketing team and continues to lead all blockchain initiatives within the compan. Denitza is an expert in the fields of real estate and blockchain economics.",
        },
    ],
    panel2: [
        {
            speakerName: "Ventsislav Topuzov",
            company: "ROITI",
            businessSphere: "Renewable Energy",
            theme: "Algorithmizing the Energy Industry",
            duration: 15,
            eventType: "Interview",
            socialLink: "https://www.linkedin.com/in/ventsislavtopuzov/",
            img: ventt,
            bio: "Ventsi is one of the founding partners at ROITI and has been serving as CEO ever since the inception of the company in 2013. ROITI excels at combining in-depth industry knowledge with the appropriate technology. They have established strong business relationships with their clients – major energy players in the European energy market, including Vattenfall, EWE, OMV, RWE, Trianel, CEZ, MET, and more. Together they design, develop, and maintain IT solutions throughout the entire wholesale and retail value chain.",
        },
        {
            speakerName: "Neville Mchina",
            company: "Invisible Foods",
            businessSphere: "Sustainability",
            theme: "Sustainable Tomorrow",
            duration: 25,
            eventType: "Panel Discussion",
            socialLink: "https://www.linkedin.com/in/neville-mchina-39203b83/",
            img: nevil,
            bio: "Impact driven entrepreneur with a heart for the African continent and its development. Strongly believe that we the diaspora, are Africa's biggest asset and it's our duty to turn this brain DRAIN into a brain GAIN!",
        },
        {
            speakerName: "Xavier Marcenac",
            company: "Nasecomo",
            businessSphere: "Sustainability",
            theme: "Sustainable Tomorrow",
            duration: 25,
            eventType: "Panel Discussion",
            socialLink: "https://www.linkedin.com/in/xaviermarcenac/",
            img: xav,
            bio: "Xavier is a seasoned executive with some 25 years experience in multinational companies in consulting, finance and M&A positions. He is the co-founder of several successful companies in the BPO industry. Xavier is the founder and now vice-chaiman of TELUS International Europe Europe, a leader in the BPO services in Europe with close to 5000 employees. He holds an MBA from INSEAD and is a graduated IT engineer as well as chartered accountant.",
        },
        {
            speakerName: "Viktoriya Markileva",
            company: "EnduroSat",
            businessSphere: "Space",
            theme: "Bringing Space Closer to You",
            duration: 10,
            eventType: "Presentation",
            socialLink: "https://www.linkedin.com/in/viktoriya-markileva/",
            img: vikm,
            bio: "Victoria graduated from Delft University of Technology with a BSc degree in Aerospace Engineering and continued her studies in Power and Propulsion for aerospace systems. She has gained experience and developed skills through the multiple university team projects such as designing an ADCS system for a Mars orbiter, creating an aircraft flight simulator model and designing a sustainable short range aircraft, which won the annual symposium award of the Aerospace Engineering faculty. She is experienced in creating mathematical models, using mission analysis software, writing technical reports and understanding aerospace technology on a systems level.",
        },
    ],
    panel3: [
        {
            speakerName: "Spas Kerimov",
            company: "Printivo",
            businessSphere: "Bio Tech",
            theme: "Printing Life: The Way to Immortality",
            duration: 15,
            eventType: "Interview",
            socialLink: "https://www.linkedin.com/in/spas-kerimov/",
            img: spas,
            bio: "Dr. Spas Kerimov is founder and CEO of Printivo, biotech company creating living tissues & organoids with 3D-bioprinting technology. Printivo is “Enterprise of the Year” for 2018 awarded by the President of Repiblic of Bulgaria. The company has won CESA Awards for two years in a row (2018,2019) as Best HealthTech startup. More awards including CIDIC Award, finalist on BetaPitch Global Berlin 2017 and etc.",
        },
        {
            speakerName: "Georgi Kostadinov",
            company: "Kelvin Health",
            businessSphere: "Bio Tech",
            theme: "Reveal the Hidden Secrets of Your Body",
            duration: 15,
            eventType: "Interview",
            socialLink: "https://www.linkedin.com/in/georgi-kostadinov/",
            img: georgik,
            bio: "Georgi has more than 10 years of experience in research and development of various machine learning algorithms for image and video understanding and over 15 years of experience in developing, deploying and managing complex software architectures.",
        },
        {
            speakerName: "Teodosy Teodosiev",
            company: "Kinetik",
            businessSphere: "Electric Vehicles",
            theme: "Drive Me to the Future",
            duration: 15,
            eventType: "Interview",
            socialLink: "https://www.facebook.com/teodosy",
            img: teod,
            bio: "Теодосий е основател на компанията Kinetik Automotive, чиито екип разработи първия електрически спортен автомобил. Също така той е сериен предприемач. Основател е на софтуерната фирма DevLabs,  базирана във Варна,  съосновател е и на единствения български стартъп преминал през най-престижния accelerator Y Combinator в силициевата долина. Завършил е Техническия университет във Варна, Executive MBA в Cotrugli Business School и след дипломна квалификация в Япония ” . Любимата дума на Теодосий е „невъзможно“, особено, когато хората я използват по отношение на неговите начинания.",
        },
        {
            speakerName: "Yonko Chuklev",
            company: "PARA",
            businessSphere: "Robotics and Automation",
            theme: "Robots Changing Factories & Supply Chains",
            duration: 15,
            eventType: "Interview",
            socialLink: "https://www.linkedin.com/in/yonko-chuklev-a7733568/",
            img: yonko,
            bio: "Yonko Chuklev is the Deputy Chairman of the Board of “Professional Association of Robotics and Automation: (PARA). He has worked on initiatives such as Robotics Strategy Forum, the first specialized exhibition on educational robotics in Bulgaria – Robo Days, the first interactive map of clubs and schools teaching robotics in Bulgaria as well as the founding of the robotics club at Sofia Tech Park Clubhouse. His professional experience includes working on projects in London and New York. He has been a lecturer at events such as TEDxSofiaUniversity and has participated as an economic and tech analyst in multiple media outlets.",
        },
    ],
};

export default panels;
